import styled from "styled-components";

const TextArea = styled.textarea`
  width: ${props => (props.width ? props.width + "px" : "100%")};
  margin: 2px;
  border: none;
  border: 1px solid ${props => props.theme.panelBorder};
  border-radius: 4px;
  padding: 4px;
  box-sizing: border-box;
  resize: none;
  background: ${props => (props.disabled ? "#ddd" : "#fff")};
`;

export default TextArea;



// WEBPACK FOOTER //
// ./src/module-common/TextArea.js